var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBg2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1263,
    height: 693,
    viewBox: "0 0 1263 693",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.686726 248.764C-0.510193 173.83 80.3898 117.104 159.527 107.059C238.663 97.015 317.626 119.608 396.39 131.55C563.58 156.884 739.016 133.063 892.061 64.2578C964.881 31.5113 1041.77 -12.4854 1120.3 4.38319C1177.96 16.7687 1222.97 61.1201 1248.36 111.238C1248.62 111.737 1248.86 112.242 1249.11 112.741C1282.17 178.99 1253.52 258.017 1184.64 292.667C1147.55 311.322 1114.67 340.21 1089.61 372.089C1042.24 432.314 1014.13 503.846 971.607 567.193C843.222 758.431 652.307 701.977 500.741 584.743C376.715 488.822 3.60194 431.277 0.686726 248.764Z",
    fill: "#009DDC",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg2);
export default __webpack_public_path__ + "static/media/bg2.8aed4b555d9d7173f216276962399853.svg";
export { ForwardRef as ReactComponent };